import { useCallback, useEffect, useRef, useState } from "react";

const useFetch = (api_call, autoFetch = false, auto_params) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const didFetch = useRef(false);

  const fetchData = useCallback(async (params) => {
    setLoading(true);
    setError(null);
    try {
      const json = await api_call(params);
      setData(json);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [api_call]);

  useEffect(() => {
    if (!didFetch.current && autoFetch) {
      fetchData(auto_params);
      didFetch.current = true;
    }
  }, [fetchData, autoFetch]);

  return { data, error, loading, refetch: fetchData };
};

export default useFetch;
